<template>
  <div class="transaction_h">
    <div class="t_h1">
      <div class="bal_list">
        <div
          class="b_item1" v-if="authjson.authjson(['2-1'])"
          :class="account_type == 3 ? 'acc_btn_act' : ''"
          @click="account_type = 3"
        >
          <div class="balance_box">
            <div>
              <div class="b_txt1">USDT {{ $t("home.text2") }}</div>
              <div class="b_txt2">$ {{ set_num3_2(usdt_balance) }}</div>
            </div>
            <div>
              <div class="b_txt1 small">USDT {{ $t("home.text1") }}</div>
              <div class="b_txt2 small">$ {{ set_num3_2(usdt_gl_balance) }}</div>
            </div>
          </div>
          <div>
            <img
              v-if="account_type == 3"
              class="b_img"
              src="../../assets/img/home_icon1.png"
              alt=""
            />
            <img
              v-else
              style="opacity: 0.2"
              class="b_img"
              src="../../assets/img/home_icon1.png"
              alt=""
            />
          </div>
        </div>
        <div
          class="b_item1" v-if="authjson.authjson(['2-2'])"
          :class="account_type == 4 ? 'acc_btn_act' : ''"
          @click="account_type = 4"
        >
          <div class="balance_box">
            <div>
              <div class="b_txt1">USDC {{ $t("home.text2") }}</div>
              <div class="b_txt2">$ {{ set_num3_2(usdc_balance) }}</div>
            </div>
            <div>
              <div class="b_txt1 small">USDC {{ $t("home.text1") }}</div>
              <div class="b_txt2 small">$ {{ set_num3_2(usdc_gl_balance) }}</div>
            </div>
          </div>
          <div>
            <img
              v-if="account_type == 4"
              class="b_img"
              src="../../assets/img/home_icon2_act.png"
              alt=""
            />
            <img
              v-else
              style="opacity: 0.2"
              class="b_img"
              src="../../assets/img/home_icon2_act.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="t_h1_top" v-if="authjson.authjson(['2-3'])">{{ $t("main.text322") }}</div>
      <div class="t_h1_box" v-if="authjson.authjson(['2-3'])">
        <el-form
          class="zdy_form"
          label-position="top"
          label-width="300px"
          :model="form"
        >
          <el-form-item :label="$t('main.text323')" class="riqi_box">
            <el-date-picker
              :editable="false"
              popper-class="time_box"
              :clearable="false"
              v-model="form.t_h_time"
              type="daterange"
              :format="v_lan == 'en' ? 'dd/MM/yyyy' : 'yyyy/MM/dd'"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('main.text324')"
              :end-placeholder="$t('main.text325')"
              :picker-options="pickerOptions2"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('main.text326')">
            <el-input v-model="form.t_h_id" placeholder=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('main.text334')">
            <el-select
              v-model="form.t_h_type"
              :placeholder="$t('main.text328')"
            >
             
              <el-option
                label="USDT-ERC20"
                value="USDT-ERC20"
                v-if="account_type == 3"
              ></el-option>
              <el-option
                label="USDT-TRC20"
                value="USDT-TRC20"
                v-if="account_type == 3"
              ></el-option>
              <el-option
                label="USDT-BEP20"
                value="USDT-BSC20"
                v-if="account_type == 3"
              ></el-option>
              <el-option
                label="USDC-ERC20"
                value="USDC-ERC20"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="USDC-TRC20"
                value="USDC-TRC20"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="USDC-BEP20"
                value="USDC-BSC20"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="USD"
                value="USD"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="SGD"
                value="SGD"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="CNY"
                value="CNY"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="GBP"
                value="GBP"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="AUD"
                value="AUD"
                v-if="account_type == 4"
              ></el-option>
              <el-option
                label="HKD"
                value="HKD"
                v-if="account_type == 4"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('main.text327')">
            <el-select
              v-model="form.trade_type"
              :placeholder="$t('main.text328')"
            >
              <el-option :label="$t('main.text328')" :value="0"></el-option>
              <el-option :label="$t('new1_txt.CR')" :value="1"></el-option>
              <el-option :label="$t('new1_txt.DR')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item class="btn_box">
            <el-button
              class="reset_btn border_set_color"
              size="medium"
              @click="reset_btn"
              >{{ $t("main.text329") }}</el-button
            >
            <el-button class="apply_btn" size="medium" @click="apply_btn">{{
              $t("main.text330")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="t_h2" v-if="authjson.authjson(['2-3'])">
      <div class="t_h2_box">
        <div>
          <div class="t_h2_txt1">{{ $t("main.text270") }}</div>
          <div class="t_h2_txt2">
            <!-- {{$t('main.text332')}} -->
            <div style="color: #12ba9c">{{ $t("main.text775") }}</div>
            <div>{{ $t("main.text776") }}</div>
          </div>
        </div>
        <div class="flex">
          <img v-if="authjson.authjson(['2-5'])"
            src="../../assets/img/Vector1.png"
            alt=""
            @click="download_pdf"
            class="pdfBtn"
          />
         
          <el-button v-if="authjson.authjson(['2-6'])"
            class="export_btn border_set_color2"
            icon="el-icon-download"
            size="medium"
            @click="download_btn"
            >CSV</el-button
          >
        </div>
      </div>
      <div class="t_h2_table zdy_tab_header">
        <el-table
          :data="tableData"
          stripe
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column :label="$t('main.text99')" min-width="120">
            <span slot-scope="props">
              {{ overall_time(props.row.c_time) }}
            </span>
          </el-table-column>

          <el-table-column :label="$t('main.text751')" min-width="260">
            <span slot-scope="props">
              <span v-html="props.row.type_name"></span>
            </span>
          </el-table-column>

          <el-table-column :label="$t('bank_card.card_username')" min-width="120">
            <span slot-scope="props">
              {{ props.row.card_username||"-" }}
            </span>
          </el-table-column>

          <el-table-column prop="tx_id" :label="$t('main.text326')" min-width="120">
          </el-table-column>

          <el-table-column :label="$t('main.text769')" min-width="120">
            <span slot-scope="props">
              <span v-if="props.row.action == 11">
                {{ set_num3_2(props.row.amount) }}
              </span>
              <span v-else>-</span>
            </span>
          </el-table-column>
          <el-table-column :label="$t('main.text770')" min-width="120">
            <span slot-scope="props">
              <span v-if="props.row.action == 10">
                {{ set_num3_2(props.row.amount) }}
              </span>
              <span v-else>-</span>
            </span>
          </el-table-column>

         
          <el-table-column :label="$t('main.text771')" min-width="120">
            <span slot-scope="props">
              {{ set_num3_2(props.row.balance) }}
            </span>
          </el-table-column>

          <el-table-column width="80">
            <span slot-scope="props">
              <img v-if="authjson.authjson(['2-4'])"
                @click="to_info(props.row.tx_id, props.row.id)"
                class="icon_width"
                src="../../assets/img/info_icon.png"
                alt=""
              />
            </span>
          </el-table-column>
        </el-table>

        <el-pagination
          v-if="tableData.length > 0"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="page_total"
          @current-change="current_change"
        ></el-pagination>
      </div>
    </div>

    <div class="download_pdf_box pdf_location">
      <PDF3 :dataList="pdf3List" :list="list" :account_type="account_type" />
      <div class="pdf-header">
        <div class="pdf-header1">
          <img src="../../assets/img/pdf_logo.png" alt="" />
          <h6>{{ $t("pdf.text19") }}</h6>
        </div>
        <div class="divv">
          <table class="headerTable table">
            <tr class="tr ant-table-row">
              <th>
                <p>{{ $t("pdf.text20") }}</p>
              </th>
              <th>
                <p>{{ $t("pdf.text21") }}</p>
              </th>
              <th>
                <p>{{ $t("pdf.text22") }}</p>
              </th>
              <th>
                <p>{{ $t("pdf.text23") }}</p>
              </th>
              <th>
                <p>{{ $t("pdf.text24") }}</p>
              </th>
              <th>
                <p>{{ $t("pdf.text15") }}</p>
                <p>({{ $t("pdf.text25") }})</p>
              </th>
            </tr>
          </table>
        </div>
      </div>
      <div class="pdf-footer">
        <div class="pdf-footer-div">
          <div class="footer">
            <div>
              <p>{{ $t("pdf.text41") }}</p>
              <p>{{ new Date() }}</p>
              <p class="pdf-header2-span"></p>
            </div>
            <div>
              <p>{{ $t("pdf.text42") }}</p>
              <p>{{ username }}</p>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  transaction_record,
  transaction_download,
  transaction_details,
  statsment,
} from "@/api/api";
import { outputPDF } from "../../utils/outputPDF";
import PDF3 from "../pdf/pdf3.vue";
// 使用时间转换插件 moment.js
import moment from 'moment'

export default {
  components: {
    PDF3,
  },
  data() {
    return {
      pickerOptions2: {
        disabledDate: (time) => {
          // 往前6个月 1号开始
          const d = Date.now() - 180 * 24 * 60 * 60 * 1000;
          const month = moment(d).format("YYYY-MM");
          const min_month = (new Date(`${month}-01 00:00:00`)).getTime();

          return (
            time.getTime() > Date.now() ||
            time.getTime() < min_month
          );
        },
      },
      form: {
        t_h_time: "",
        t_h_id: "",
        t_h_type: "",
        trade_type: 0,
        balance_type: "USDC",
      },
      username: sessionStorage.getItem("username"),
      currentPage: 1, //选中的页数
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      page_total: 0, //一共多少条
      tableData: [],
      account_type: 3, //	Number	1BTC 2ETH 3USDT 4USDC

      usdt_balance: 0,
      usdc_balance: 0,

      usdt_gl_balance: 0,   // USDT总账余额
      usdc_gl_balance: 0,   // USDC总账余额

      pdf3List: {},
      list: [],
    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  watch: {
    account_type() {
      this.get_list();
    },
  },
  mounted() {
    this.get_list();
  },
  methods: {
    async download_pdf(y, m) {
      this.y = y;
      this.m = m;
      this.days = new Date(y, m, 0).getDate();

      await statsment({
        page: this.page,
        limit: this.limit,
        start_date: this.form.t_h_time ? this.form.t_h_time[0] : "",
        end_date: this.form.t_h_time ? this.form.t_h_time[1] : "",
        tx_id: this.form.t_h_id,
        status: "",
        // tx_type: this.form.trade_type,
        action: this.form.trade_type,
        account_type: this.account_type,
        token_type: this.form.t_h_type,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pdf3List = res.data.data;
          this.list = res.data.data.list;
        } else {
          this.$message.error(res.data.msg);
        }
      });

      const element = document.querySelector(".download_pdf_box");
      const header = document.querySelector(".pdf-header");
      const footer = document.querySelector(".pdf-footer");
      try {
        await outputPDF({
          element: element,
          footer: footer,
          header: header,
          contentWidth: 560,
        });
      } catch (error) {
        this.$message.error(
          typeof error === "string" ? error : JSON.stringify(error)
        );
      }
    },
    reset_btn() {
      this.form.t_h_time = "";
      this.form.t_h_id = "";
      this.form.t_h_type = "";
      this.form.trade_type = 0;
      this.form.balance_type = "USDC";
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    apply_btn() {
      // console.log(this.form);
      this.page = 1;
      this.limit = 10;
      this.currentPage = 1;
      this.get_list();
    },
    get_list() {
      transaction_record({
        page: this.page,
        limit: this.limit,
        start_date: this.form.t_h_time ? this.form.t_h_time[0] : "",
        end_date: this.form.t_h_time ? this.form.t_h_time[1] : "",
        tx_id: this.form.t_h_id,
        status: "",
        // tx_type: this.form.trade_type,
        action: this.form.trade_type,
        account_type: this.account_type,
        token_type: this.form.t_h_type,
      }).then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          this.page_total = res.data.data.count;
          this.tableData = res.data.data.list;
        }
      });

      transaction_details().then((res) => {
        if (res.data.code == 200) {
          // console.log(res.data.data);
          this.usdt_balance = res.data.data.usdt_balance;
          this.usdc_balance = res.data.data.usdc_balance;
          this.usdt_gl_balance = res.data.data.usdt_gl_balance;
          this.usdc_gl_balance = res.data.data.usdc_gl_balance;
        }
      });
    },
    cellStyle({ row }) {
      // tx_type: 1加密货币 2法币 法币 那行为绿色文字
      if (row.tx_type == 2) {
        return "color:#12BA9C";
      } else {
        return "";
      }
    },
    current_change(v) {
      // console.log(v);
      this.page = v;
      this.limit = 10;
      this.get_list();
    },
    to_info(tx_id, id) {
      sessionStorage.setItem("my_info_tx_id", tx_id);
      sessionStorage.setItem("my_info_id", id);
      setTimeout(() => {
        this.$router.push("/my_transaction_info");
      }, 100);
    },
    download_btn() {
      if (this.page_total <= 0) {
        return this.message.ismessage("error", this.$t("main.text335"));
      }
      transaction_download({
        start_date: this.form.t_h_time ? this.form.t_h_time[0] : "",
        end_date: this.form.t_h_time ? this.form.t_h_time[1] : "",
        tx_id: this.form.t_h_id,
        status: "",
        // tx_type: this.form.trade_type, 
        action: this.form.trade_type, 
        account_type: this.account_type,
        token_type: this.form.t_h_type,
      }).then((res) => {
        const filename =
          res.headers["content-disposition"].split(";")[1].split("=")[1] ||
          "download.xlsx";
        const link = document.createElement("a");
        const blob = new Blob([res.data], { type: "application/octet-stream" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${filename}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pdfBtn {
  height: 40px;
  margin-right: 20px;
  cursor: pointer;
}
.flex {
  display: flex;
  margin-top: 20px;
  align-items: center;
}
.divv {
  height: 52px;
}
.table {
  border-collapse: collapse;
  display: none;
  margin: 0 60px 10px 60px;
  .tr th {
    border-bottom: 1px solid #000;
    padding: 5px;
    text-align: right;
  }
  .tr th {
    background: #d0d3d4;
    padding: 5px;
  }
  tr:nth-child(odd) {
    background: #f5f6f6;
  }
  tr th:nth-child(1) {
    text-align: left;
    width: 80px;
  }
  tr th:nth-child(2) {
    text-align: left;
    width: 150px;
  }
  tr th:nth-child(3) {
    text-align: left;
    width: 270px;
  }
  tr th:nth-child(4) {
    width: 100px;
    text-align: right;
  }
  tr th:nth-child(5) {
    width: 100px;
    text-align: right;
  }
  tr th:nth-child(6) {
    text-align: right;
    width: 120px;
  }
}
</style>
<style scoped>
.pdf-header {
  position: fixed;
  top: -100vh;
  width: 1000px;
}
.pdf-header1 {
  display: flex;
  justify-content: space-between;
  margin: 30px 60px;
  align-items: flex-end;
}
.pdf-header1 img {
  width: 150px;
}
.pdf-header1 h6 {
  font-size: 26px;
}
.pdf-footer {
  position: fixed;
  top: -100vh;
  width: 1000px;
}
.footer {
  border: 1px solid black;
  border-radius: 2px;
  margin: 0 50px 10px 60px;
  padding: 10px;
  font-size: 14px;
}
.footer div {
  display: flex;
  justify-content: space-between;
}
.footer div p:nth-child(1) {
  width: 200px;
}
.footer div p:nth-child(2) {
  flex: 1;
}
.pdf_location {
  color: #000;
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  background: #fff;
  z-index: 2;
  width: 900px;
}

.t_h1_top {
  /* margin-top: 40px; */
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box {
  background: #314b69;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item {
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select {
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child {
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
  font-size: inherit;
}
.zdy_form >>> .el-input__inner {
  background: #223c58;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus {
  color: #deb981;
  /* border-style:solid; */
  /* border-width: 1.5px; */
  /* border-color:#ECBD75 #E3A84E #ECBC74 #F1C788; */
  /* background: transparent; */
  min-width: 120px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
}

.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus {
  min-width: 120px;
  border-color: #f1c788;
  background: linear-gradient(90deg, #f1c788 0.42%, #e3a84e 100.42%);
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #04182a;
}
.zdy_form .btn_box {
  width: auto;
}
.t_h2_box {
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  align-items: center;
}
.t_h2_txt1 {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus {
  color: #deb981;
  border-style: solid;
  border-width: 1.5px;
  border-color: #ecbd75 #e3a84e #ecbc74 #f1c788;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  min-width: 120px;
  background: transparent;
}
.pdf_btn,
.pdf_btn:hover,
.pdf_btn:active,
.pdf_btn:focus {
  color: rgb(18, 186, 156);
  border-style: solid;
  border-width: 1.5px;
  border-color: rgb(18, 186, 156) rgb(18, 186, 156) rgb(18, 186, 156)
    rgb(18, 186, 156);
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  min-width: 120px;
  background: transparent;
}
.icon_width {
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.acc_list {
  margin-bottom: 10px;
}
.acc_btn {
  background-color: transparent;
  border: 1.5px solid #f1c788;
  color: #deb981;
  min-width: 70px;
}
.acc_btn_act {
  background: #deb981 !important;
}
/* ---- */
.bal_list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
  color: #fff;
}
.b_item1 {
  width: 100%;
  max-width: 400px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
  background: #04182a;
  border-radius: 16px;
  margin-right: 20px;
  cursor: pointer;
}
.b_txt1 {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  opacity: 0.8;
  /* padding-bottom: 12px; */
}
.b_txt1.small {
  padding-top: 12px;
  font-size: 12px;
}
.b_txt2 {
  font-size: 28px;
}
.b_txt2.small {
  font-size: 20px;
}
.b_img {
  max-width: 68px;
}

/* ---- */
</style>

